import React from "react";
import styled from "styled-components";

const Card = styled.button`
  appearance: none; border: 0; background: #fff;
  width: 100%; aspect-ratio: 1 / 1.08;
  border-radius: 16px; cursor: pointer; position: relative;
  box-shadow: 0 6px 18px rgba(0,0,0,.06);
  padding: 14px 12px 10px;
  display: grid; grid-template-rows: 1fr auto; gap: 10px;
  transition: transform .12s ease, box-shadow .12s ease, filter .12s ease;

  &:hover { transform: translateY(-2px); box-shadow: 0 10px 24px rgba(0,0,0,.10); }
  &:active { transform: translateY(0); box-shadow: 0 6px 18px rgba(0,0,0,.08); }
`;

const Figure = styled.div`
  position: relative; display: grid; place-items: center; overflow: hidden;
  &::after{
    content:""; position:absolute; inset:0;
    background: radial-gradient(120% 80% at 20% 10%, rgba(255,255,255,.55) 0%, rgba(255,255,255,0) 60%);
    pointer-events:none;
  }
`;

const MapImg = styled.img`
  width: 88%; height: auto; object-fit: contain; display: block;
  /* 핵심: 입체감 */
  filter: drop-shadow(0 3px 6px rgba(0,0,0,.22)) saturate(1.06) brightness(1.02) contrast(1.02);
  transition: transform .12s ease, filter .12s ease;

  ${Card}:hover & { transform: scale(1.03); filter: drop-shadow(0 6px 12px rgba(0,0,0,.26)) saturate(1.1); }
  ${Card}:active & { transform: scale(0.985); }
`;

const Title = styled.div`
  display:flex; align-items:center; justify-content:center; gap:8px;
  font-weight: 900; color: #0f172a; font-size: 15px;
`;

const Dot = styled.i`
  width: 8px; height: 8px; border-radius: 50%;
  background: ${(p) => p.color || "#7DB3FF"};
  box-shadow: 0 0 0 3px ${(p) => p.ring || "rgba(125,179,255,.20)"};
`;

export default function RegionCard({ title, imgSrc, accent = "#7DB3FF", onClick }) {
    return (
        <Card onClick={onClick} aria-label={`${title} 보기`}>
            <Figure><MapImg src={imgSrc} alt={title} /></Figure>
            <Title><Dot color={accent} /> {title}</Title>
        </Card>
    );
}
